import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";


import zulick89 from '../images/articlePictures/zulick89.png'
import zulick86 from '../images/articlePictures/zulick86.png'


const options = {
    thumbnails: {
        showThumbnails: false
    // buttons: {
    //   backgroundColor: "#1b5245",
    //   iconColor: "rgba(126, 172, 139, 0.8)",
    // },
    // caption: {
    //   captionColor: "#a6cfa5",
    //   captionFontFamily: "Raleway, sans-serif",
    //   captionFontWeight: "300",
    //   captionTextTransform: "uppercase",
    }
  };

const ConradZulickBio = () => (

<React.Fragment>
<Segment  style={{ padding: '0em 0em' }} vertical>
    <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
            <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                <Header as='h3' style={{ fontSize: '2em' }}>Conrad Meyer Zulick <br/>  (1839 - 1926)  </Header>
                <br/>
            </Grid.Column>
        </Grid.Row>

        <Grid.Row textAlign='left'>
            <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                <SimpleReactLightbox>
                    <SRLWrapper>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={zulick89} class="articlePhoto" alt="1885 - 1889 - Taken sometime during his governership" />
                </div>
                <br/>
                Conrad was born on June 3, 1838 to Anthony Zulick and Martha Cummings.  He was educated by private tutors at Minerva Hall.  He was admitted to the New Jersey Bar in June of 1860 and took active part in Stephen Douglas’s run for the presidency later that same year.  He was appointed adjutant to the 2nd Division of Colored Volunteers during the Civil War.  Later a service disability resulted in his discharge from the army and he returned to Newark. 
                <br/>
                <br/>
                Back in Newark, he began his mining company, the New Jersey and Sonora Mining Company.
                <br/>
                <br/>
                In 1885, Conrad went to Sonora to help some clients who had lost money in one of his mine developments.  But instead, he became a hostage of the mine employees.  Under Mexican law, a manager could be jailed until wages of the workers were paid.
                <br/>
                <br/>
                While in jail, President Grover Cleveland appointed him as the seventh Governor of Arizona.  At the same time, President Cleveland appointed W.K. Meade of Tombstone as United States Marshall of Arizona.  Marshall Meade arranged for M.T. “Doc” Donovan, a former scout for General Crook during the Apache wars, to get him out.  Donovan entered the mining camp at night and at 2 A.M., he snuck past a sleeping guard and awakened Zulick.  He put Zulick in the bottom of a wagon and slowly left the town.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={zulick86} class="articlePhoto" alt="1886 - April 3. An article about his appointment printed in a Pennyslvannia Newspaper" />
                </div>
                <br/>
                <br/>
                After they crossed the border, Donovan told Zulick about his appointment.  Their first stop was Tombstone.
                <br/>
                <br/>
                Tombstone was excited.  Only a few years old, mining had already brought in millions of dollars, and now the biggest town in Arizona, it wanted to be the Territorial Capital.  They provided a lavish dinner at the Occidental Hotel that was attended by all the notables of the city.
                <br/>
                <br/>
                The next stop was Tucson.  They arranged a huge banquet at the San Xavier Mission, which was the social event of the season.
                <br/>
                <br/>
                Arizona greeted him warmly.  On October 24, from John Marion, editor of the Arizona Miner:
                <br/>
                <br/>
                “He will enter upon his official duties with the best wishes and moral support of every resident of the Territory.”
                <br/>
                <br/>
                Marion disliked Republicans.  In his first editorial, he had written: “We shall labor, with whatever reason our Maker has vouch-safed us, to cripple the Republican monster that has grown fat upon the misfortunes of our country.”
                <br/>
                <br/>
                Marion was overjoyed in welcoming Arizona’s first Democratic governor.  However, and unfortunately for Zulick, Marion not only disliked Republicans but disliked Apaches, and had joined others in planning a militia-type group of citizens to run them out of the area.
                <br/>
                <br/>
                Zulick, like many Easterners, had mixed feelings.  Shortly after his arrival, in his Proclamation of December 23, 1885, he warned the people “Not to take the law into your hands to punish the Apaches.” as Marion and others had planned.  This could make their plans illegal.  Marion turned against him.
                <br/>
                <br/>
                Increasingly Zulick was charged with wrongdoings.  He was accused of selling the Vulture Mine to Eastern investors; “This wouldn’t have been regarded as sinister had he owned the mine,” and placing mounted tax collectors along the Mexican border and not accounting for the taxes collected.
                <br/>
                <br/>
                The good things he did were largely ignored.  He corrected legislation, which disenfranchised all Mormons, saying, “A man may be an advocate of bigamy, or polygamy, or belong to a church that so believes, but until he puts forth his belief in practice he had offended no law.”  Since most of his opponents weren’t fond of Mormons, it did little to improve his standing with the people of Prescott, being called “A failure and a political trickster of the smallest caliber.”
                <br/>
                <br/>
                On March 10, 1887, he announces the end to the Indian Wars.  He established an upper limit placed on the territorial debt.  He encouraged canal building and water irrigation with such projects as the Arizona Canal, in the Glendale area, dam building, and the expansion of the Salt River Project.
                <br/>
                <br/>
                He also advocated statehood by the introduction of Public Act number 59, which called for a constitutional convention.  He felt that territorial status was the same as being a colony of the United States because it had no representation.
                <br/>
                <br/>
                Zulick no longer felt he could walk the streets of Prescott.  When he entered the Prescott Opera House in January of 1889, he was greeted with hissing and foot-stomping.
                <br/>
                <br/>
                On January 26, 1889, he signed Legislative Act Number 1, which stated, “On and after the 4th day of February, in the year of our Lord Eighteen Hundred and Eighty-nine, the permanent seat of Government and Capital of this Territory shall be at the City of Phoenix.”
                <br/>
                <br/>
                Zulick and the legislators didn’t wait until February to move.  Three days after the bill was signed, they headed fro Phoenix, scorning the quicker Black Canyon Stage and traveling regally in tow Pullman cars via Los Angeles, all paid for by the Santa Fe and Southern Pacific.
                <br/>
                <br/>
                The Governor’s days were numbered after Republican Benjamin Harrison defeated Cleveland in 1889.  Territorial governors were appointed, not voted into office, and Zulick was replaced immediately.
                <br/>
                <br/>
                Zulick remained in Arizona for several years and was elected Maricopa County Councilman in 1891.
                <br/>
                <br/>
                In 1920, at 80, he lived on Savanna Avenue in Asbury Park, New Jersey.  He lived there with his wife Caroline, age 76, and their daughter Lillian Ramsey, age 52.
                <br/>
                <br/>
                He died at the age of 86.
                <br/>
                    </SRLWrapper>
                </SimpleReactLightbox>
                </p>
            </Grid.Column>
        </Grid.Row>
        </Grid>
    </Segment>
</React.Fragment>
)

export default ConradZulickBio